import { NotebookIcon } from './NotebookIcon';

/**
 * author: Gabriel Grant
 * id 2D28230E-DAF3-4A49-ACB6-7D9C3E9E6495
 * name notebook
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/notebook.svg
 * tags
 */
export const PlannerIcon = NotebookIcon;
export default PlannerIcon